module.exports = __webpack_public_path__ + "static/media/connect-four-animated.6f783132.gif";